var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.notes),function(note){return _c('note',{key:note.id,attrs:{"note":note},on:{"delete-note":_vm.deleteNote,"update:note":function($event){note=$event}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }